import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=3a95a0bc&scoped=true"
import script from "./integral.vue?vue&type=script&lang=js"
export * from "./integral.vue?vue&type=script&lang=js"
import style0 from "./integral.vue?vue&type=style&index=0&id=3a95a0bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95a0bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a95a0bc')) {
      api.createRecord('3a95a0bc', component.options)
    } else {
      api.reload('3a95a0bc', component.options)
    }
    module.hot.accept("./integral.vue?vue&type=template&id=3a95a0bc&scoped=true", function () {
      api.rerender('3a95a0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serve/integral.vue"
export default component.exports